define('TescoMobile_Customer/js/view/account/manage-one-off-minutes',['uiComponent', 'ko', 'jquery', 'Magento_Catalog/js/price-utils', 'Magento_Ui/js/modal/modal', 'mage/url', 'domReady!'], function (Component, ko, $, priceUtils, modal, url) {
  'use strict';

  url.setBaseUrl(window.BASE_URL);
  return Component.extend({
    selectedMinutesBundle: ko.observable(false),
    selectedMinutesBundleCode: ko.observable(),
    formKey: ko.observable($.mage.cookies.get('form_key')),
    formUrl: url.build('customer/account/updateoneoffminutes'),
    initialize: function () {
      this._super();
      this.scheduledRefillDate = ko.observable(this.scheduledRefillDate);
      this.termsAndConditionsContent = ko.observable(this.termsAndConditionsContent);
      this.renewalRemainingDays = ko.observable(this.renewalRemainingDays);
      this.bundleGroupCode = ko.observable(this.bundleGroupCode);
      this.availableOneOffMinutesBundles = ko.observableArray(this.availableOneOffMinutesBundles);
    },
    defaults: {
      template: 'TescoMobile_Customer/account/one-off-minutes.html'
    },
    openConfirmationModal: function (element) {
      var self = this;
      self.selectedMinutesBundle(element.label + ' - ' + this.formatPrice(element.price));
      self.selectedMinutesBundleCode(element.code);
    },
    formatPrice: function (price) {
      let priceFormat = {
        decimalSymbol: '.',
        integerRequired: false,
        pattern: "£%s",
        precision: 2,
        requiredPrecision: 2
      };
      return priceUtils.formatPrice(price, priceFormat);
    },
    setModalElement: function (element) {
      $(".customer-account-manage-minutes-grid .item").click(function () {
        $(this).addClass('selected').siblings().removeClass('selected');
        ;
      });
      var self = this;
      var options = {
        modalClass: 'confirmation-message-minutes-bundle',
        responsive: true,
        innerScroll: true,
        'trigger': '#confirmation-modal-trigger',
        type: 'popup',
        clickableOverlay: false
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
    },
    closeModal: function () {
      $(this.modalWindow).modal('closeModal');
    },
    showLoader: function () {
      $(".customer-account-manage-confirmation-popup button.confirm").click(function () {
        $(this).trigger('processStart');
      });
    }
  });
});

